import { render, staticRenderFns } from "./IsOwnerIndicator.vue?vue&type=template&id=37b3c170"
import script from "./IsOwnerIndicator.vue?vue&type=script&lang=js"
export * from "./IsOwnerIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports